import PropTypes from 'prop-types';
// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
// import EditOutlined from '@ant-design/icons/EditOutlined';
// import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import RedoOutlined from '@ant-design/icons/RedoOutlined';
// import UserOutlined from '@ant-design/icons/UserOutlined';
import { useAuth } from 'sections/authentication/context/UseAuth';
// Must come from react-router-dom, not react-router: react-router is pinned to
// 7.9.4 while react-router-dom 7.18.4 installs its own nested react-router
// 7.18.4. Importing from 'react-router' resolves to the other copy, whose
// Router context is never populated by RouterProvider, so useNavigate() threw
// "may be used only in the context of a <Router> component" on logout.
import { useNavigate } from 'react-router-dom';
import ResetPasswordDialog from './ResetPasswordDialog';
import { useState } from 'react';
// import WalletOutlined from '@ant-design/icons/WalletOutlined';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [resetOpen, setResetOpen] = useState(false);

  const handleLogout = () => {
    logout();

    // Redirect to login
    navigate('/login', { replace: true });
  };
  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      {/* <ListItemButton>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="Edit Profile" />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="View Profile" />
      </ListItemButton> */}

      {/* <ListItemButton>
        <ListItemIcon>
          <ProfileOutlined />
        </ListItemIcon>
        <ListItemText primary="Social Profile" />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <WalletOutlined />
        </ListItemIcon>
        <ListItemText primary="Billing" />
      </ListItemButton> */}
      <ListItemButton onClick={() => setResetOpen(true)}>
        <ListItemIcon>
          <RedoOutlined />
        </ListItemIcon>
        <ListItemText primary="Reset Password" />
      </ListItemButton>
      <ListItemButton onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
      <ResetPasswordDialog open={resetOpen} onClose={() => setResetOpen(false)} />
    </List>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func };
